import styled from 'styled-components';

export default styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;

    @media (min-width: 815px) {
        .addressAutoComplete-input-wrapper > div {
            flex: 0 0 32%;
        }
        .addressAutoComplete-input-wrapper {
            justify-content: flex-start;
            gap: 2%;
        }
    }
`;
